// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export const useAccountBalanceCredits = () =>
    useAppSelector(state => state.bunzl.pages.accountBalance.accountBalance?.credits) ?? [];
export const useIsAccountBalanceLoading = () => useAppSelector(state => state.bunzl.pages.accountBalance.isLoading);

export default () => useAppSelector(state => state.bunzl.pages.accountBalance);
